import { Reveal } from "@/components/Motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Small batches, big voices",
    text: "Never more than ten learners per batch. You speak from day one — every class is a conversation, not a lecture.",
  },
  {
    n: "02",
    title: "Certification-first teaching",
    text: "Every syllabus maps to the world's benchmarks — Goethe-Zertifikat, DELF and TOPIK — so your effort converts into credentials.",
  },
  {
    n: "03",
    title: "Culture with the grammar",
    text: "Films, food, festivals and conversation clubs. You don't just learn a language at Edvio — you start living it.",
  },
];

export default function Manifesto() {
  return (
    <section id="method" className="relative py-28 lg:py-40 bg-[#081B40] border-y border-white/10 overflow-hidden" data-testid="manifesto-section">
      <img src="/edvio-bird.png" alt="" className="absolute -left-16 bottom-[-8%] w-[380px] lg:w-[520px] opacity-[0.05] -scale-x-100 rotate-6 pointer-events-none select-none" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#C44900] mb-6" data-testid="manifesto-eyebrow">02 — The Edvio Method</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl tracking-tighter text-[#F4F4F0] leading-[1.02] max-w-3xl">
            A manifesto for <em className="italic text-[#A3A3A3]">serious</em> learners.
          </h2>
        </Reveal>

        <div className="mt-16 lg:mt-24">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="group grid md:grid-cols-[220px_1fr] gap-6 md:gap-16 py-10 lg:py-14 border-t border-white/10" data-testid={`manifesto-chapter-${c.n}`}>
                <span className="font-display text-6xl lg:text-8xl text-stroke leading-none transition-all duration-500 group-hover:[-webkit-text-stroke-color:#C44900]">{c.n}</span>
                <div className="max-w-2xl">
                  <h3 className="font-display text-2xl lg:text-4xl tracking-tight text-[#F4F4F0]">{c.title}</h3>
                  <p className="mt-4 text-sm lg:text-base text-[#A3A3A3] leading-relaxed">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
